import { shuffle } from "appworks/utils/collection-utils";
import { slotDefinition } from "slotworks/model/slot-definition";
import { SymbolConfig } from "slotworks/model/symbol-definition";

const slingoSymbolDefs: SymbolConfig[] = [];
const slotSymbolDefs: SymbolConfig[] = [];

export function FowlGameDefinitionSetup() {
    slotDefinition.matrixGrid = [1, 1, 1, 1, 1];

    SymbolDefinitions();

    ReelSets();
}

function SymbolDefinitions() {
    // slot bonus symbols

    for (let i = 1; i <= 75; i++) {
        slingoSymbolDefs.push({ id: "numbers/" + i });
    }
    slingoSymbolDefs.push(
        { id: "blank", isBlank: true },
        { id: "J" },
        { id: "SJ" },
        { id: "FS" },
        { id: "P", scatter: true, anticipation: 2, matchesMin: 3, reels: [0, 1, 2, 3, 4] }
    );

    // weird ordering to match up what the server sends and the hierarchy benny wanted
    slotSymbolDefs.push(
        { id: "slotbonus_L0" },
        { id: "slotbonus_L2" },
        { id: "slotbonus_L1" },
        { id: "slotbonus_L4" },
        { id: "slotbonus_L3" },
        { id: "slotbonus_H2" },
        { id: "slotbonus_H3" },
        { id: "slotbonus_H1" },
        { id: "slotbonus_WI", wild: true },
        { id: "slotbonus_SC", scatter: true, anticipation: 2, matchesMin: 3, reels: [0, 1, 2, 3, 4] }
    );

    slotDefinition.processSymbols([...slotSymbolDefs, ...slingoSymbolDefs]);
}

function ReelSets() {
    const numbers: string[] = [];
    for (let i = 1; i <= 75; i++) {
        numbers.push("numbers/" + i);
    }

    if (!slotDefinition.reelsets) {
        slotDefinition.reelsets = new Map();
    }

    slotDefinition.reelsets.set("slingo", [[...shuffle(numbers)], [...shuffle(numbers)], [...shuffle(numbers)], [...shuffle(numbers)], [...shuffle(numbers)]]);
}
